module.exports = __webpack_public_path__ + "img/38_29.be5daa77.png";